import React, { useState } from "react"
import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { sendInvoiceWhatsApp } from "helpers/backendHelpers/manageSubscription"

const labelFor = ({ status, count, error }) => {
  if (status === "sent") return `${Math.max(1, Number(count || 0))} Sent`
  if (status === "sending") return "Sending..."
  if (status === "failed" && error === "not_on_whatsapp") return "Not on WhatsApp"
  if (status === "failed") return "Failed"
  return "Not sent"
}

const colorFor = ({ status, error }) => {
  if (status === "sent") return "success"
  if (status === "failed" && error === "not_on_whatsapp") return "warning"
  return "secondary"
}

export default function InvoiceWhatsAppCell({ payment, onSent }) {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [sending, setSending] = useState(false)
  const paymentId = payment?._id || payment?.paymentId
  const status = payment?.invoiceWhatsAppStatus
  const count = payment?.invoiceWhatsAppSendCount
  const error = payment?.invoiceWhatsAppError
  const alreadySent = status === "sent" && Number(count || 0) > 0
  const canSend = paymentId && payment?.invoiceUrl && !payment?.isInvoiceCancelled && payment?.invoiceStatus !== "cancelled"

  const send = async () => {
    if (!canSend || sending) return
    try {
      setSending(true)
      await sendInvoiceWhatsApp(paymentId)
      setConfirmOpen(false)
      onSent?.()
    } finally {
      setSending(false)
    }
  }

  const handleClick = () => {
    if (alreadySent) setConfirmOpen(true)
    else send()
  }

  return (
    <div className="d-flex flex-column gap-1 align-items-start">
      <Badge color={colorFor({ status, error })}>{labelFor({ status, count, error })}</Badge>
      {payment?.invoiceWhatsAppSentAt && status === "sent" && (
        <small className="text-success">Last sent {new Date(payment.invoiceWhatsAppSentAt).toLocaleDateString()}</small>
      )}
      {canSend && (
        <Button color={status === "failed" ? "warning" : "primary"} outline size="sm" onClick={handleClick} disabled={sending || status === "sending"}>
          {sending || status === "sending" ? "Sending..." : status === "failed" ? "Retry Send Invoice" : "Send Invoice"}
        </Button>
      )}
      <Modal isOpen={confirmOpen} toggle={() => setConfirmOpen(false)} centered>
        <ModalHeader toggle={() => setConfirmOpen(false)}>Resend Invoice on WhatsApp</ModalHeader>
        <ModalBody>
          This invoice was automatically sent on WhatsApp. Do you want to resend it?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button color="primary" onClick={send} disabled={sending}>{sending ? "Sending..." : "Resend Invoice"}</Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}
